import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StringHelper } from '../../../core/helpers/strings.helper';
import { MobileDelegateService } from '../../../core/services/mobile-delegate.service';
import { DelegateType } from '../../../shared/models/utility.model';

@Component({
    selector: 'app-kamona-otp',
    templateUrl: './kamona-otp.component.html',
    styleUrls: ['./kamona-otp.component.scss'],
})
export class KamonaOtpComponent implements OnInit {
    @Output() emitInput = new EventEmitter();
    @Input() noOfPin = 6;
    @Input() type = 'text';
    @Input() id = 'pin';
    @Input() idV2 = 'otp';
    @Input() inputReadonly = false;
    pinArray: string[] = [];
    savedPin: string[] = [];
    totalIndex: number;
    KamonaOtpVersion = KamonaOtpVersion;
    @Input() version = KamonaOtpVersion.version_1;
    readonly DEFAULT_VALUE = '';
    readonly FIRST_PIN_NO = 1;

    constructor(private delegateService: MobileDelegateService) {}

    ngOnInit(): void {
        const pinBox = this.getHtmlElement();
        pinBox.addEventListener('paste', (event) => {
            const paste: string = (event?.[`clipboardData`] || window[`clipboardData`]).getData('text');
            const validOtp = StringHelper.validOTP(paste) && this.noOfPin === paste?.length;
            if (validOtp) {
                const arr = paste.split('');
                this.savedPin = [...arr];
                this.emitInput.emit(this.getPin(this.savedPin));
            }
        });
        this.totalIndex = this.noOfPin - this.FIRST_PIN_NO;
        this.pinArray = new Array(this.noOfPin).fill(this.DEFAULT_VALUE);
        this.savedPin = new Array(this.noOfPin).fill(this.DEFAULT_VALUE);
    }

    getHtmlElement() {
        if (this.version === KamonaOtpVersion.version_1) {
            return document.getElementById(`otp-container-box`);
        }
        return document.querySelector('.kamona_otp_version_2');
    }

    callFocus(id) {
        const input = document.getElementById(`${this.getId()}-${id}`);
        input?.focus();
        // @ts-ignore
        input?.setSelectionRange(1, 1);
    }

    getId() {
        return this.version === KamonaOtpVersion.version_1 ? this.id : this.idV2;
    }

    getNextIndex(savedPin: any[]) {
        // tslint:disable-next-line:radix
        return savedPin.findIndex((e) => !StringHelper.validNumber(parseInt(e)));
    }

    getPreviousIndex(savedPin: any[]) {
        // tslint:disable-next-line:radix
        const filledBoxes: any[] = savedPin.filter((e) => StringHelper.validNumber(parseInt(e)));
        return savedPin.lastIndexOf(filledBoxes[filledBoxes.length - 1]);
    }

    getPin(savedPin: any[]) {
        let pin = ``;
        savedPin.forEach((e) => {
            pin += `${e}`;
        });
        return pin;
    }

    handleOnKeyupEvent($event: KeyboardEvent, index: number) {
        let input = $event.target[`value`];
        input = StringHelper.numbersOnly(input);
        $event.target[`value`] = input;
        $event.target[`defaultValue`] = input;
        this.savedPin = [...this.savedPin];
        this.savedPin[index] = input;
        this.emitInput.emit(this.getPin(this.savedPin));
        input ? this.fillInputField(this.savedPin, index) : this.emptyInputField(this.savedPin, index);
    }

    handleOnKeydownEvent(key, index: number) {
        const html = document.getElementById(`${this.idV2}-${index}`);
        if (!html) {
            return;
        }
        const event = new KeyboardEvent('keydown', { key, ctrlKey: true });
        html.dispatchEvent(event);
        event.target[`value`] = `${key}`;
    }

    fillInputField(savedPin: any[], index) {
        // this.maskInput(index);
        const nextIndex = this.getNextIndex(savedPin);
        this.callFocus(nextIndex);
    }

    emptyInputField(savedPin: any[], index) {
        // this.unMaskInput(index);
        const previousIndex = this.getPreviousIndex(savedPin);
        this.edgeCase(previousIndex);
    }

    edgeCase(index) {
        if (index >= 0) {
            this.callFocus(index);
        }
    }

    async onPaste(ev) {
        // auto copy paste from clipboard when input gets focussed
        return;
        if (!ev.relatedTarget) {
            try {
                const hasValue = await this.delegateService.getDelegateData(DelegateType.getClipboardData);
                if (hasValue) {
                    this.populateAllInputs(hasValue);
                } else {
                    navigator.clipboard.readText().then((text) => {
                        this.populateAllInputs(text);
                    });
                }
            } catch (error) {
                navigator.clipboard.readText().then((text) => {
                    this.populateAllInputs(text);
                });
            }
        }
    }

    populateAllInputs(text) {
        let pastedChars = text.split('');
        pastedChars = pastedChars.slice(0, this.noOfPin);
        pastedChars.forEach((t, index) => {
            t = StringHelper.numbersOnly(t);
            this.savedPin = [...this.savedPin];
            this.savedPin[index] = t;
            this.emitInput.emit(this.getPin(this.savedPin));
            this.fillInputField(this.savedPin, index);
        });
    }
}

export enum KamonaOtpVersion {
    version_1 = 1,
    version_2 = 2,
}
